import { COLUMN_DOOR, COLUMN_NAME, COLUMN_SITE } from "../../constants/column-types";
import { FILTER_SITES } from "../../constants/filter-types";
import { TableColumn } from "../table/TableColumn";

const AccessAreaColumns : TableColumn[] = [
    {
        heading: "Name",
        accessor: "name",
        isNumeric: false,
        id: 0,
        sortByName: "areaName",
        sortDirection: "asc",
        active: true,
        translationKey: "name",
        isDefault: true,
        columnId: COLUMN_NAME,
    },
    {
        heading: "Site",
        accessor: "site",
        isNumeric: false,
        id: 1,
        sortByName: "site.siteName",
        sortDirection: "asc",
        active: true,
        searchOnName: "site.id",
        lookupName: "site.siteName",
        translationKey: "site",
        filterId: FILTER_SITES,
        settingDataName: 'site',
        columnId: COLUMN_SITE,
    },
    {
        heading: "Doors",
        accessor: "doors",
        isNumeric: true,
        id: 2,
        active: true,
        translationKey: "doors",
        columnId: COLUMN_DOOR,
    },
    {
        heading: "Door",
        accessor: "liftDoor",
        isNumeric: true,
        id: 3,
        active: true,
        translationKey: "door",
        columnId: COLUMN_DOOR,
    },
];


export default AccessAreaColumns;
